/**
 * Temporary storage for browser File objects
 * 
 * Since File objects can't be serialized in Redux, we store them here temporarily
 * and store only metadata (with a file key) in Redux state.
 */

// In-memory storage for File objects
const fileStore = new Map();

/**
 * Store a File object and return a unique key and metadata
 */
export function storeFile(file) {
  // Generate a unique key for this file
  const fileKey = `file_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
  // Store the actual File object
  fileStore.set(fileKey, file);
  
  // Return metadata that can be stored in Redux
  return {
    fileKey,
    name: file.name,
    path: file.path || file.webkitRelativePath || file.name,
    size: file.size,
    type: file.type,
    lastModified: file.lastModified,
    isUploadedFile: true // Flag to indicate this needs actual upload
  };
}

/**
 * Retrieve a File object by its key
 */
export function getFile(fileKey) {
  return fileStore.get(fileKey);
}

/**
 * Remove a File object from storage
 */
export function removeFile(fileKey) {
  fileStore.delete(fileKey);
}

/**
 * Clear all stored files
 */
export function clearAllFiles() {
  fileStore.clear();
}

/**
 * Get all stored file keys
 */
export function getAllFileKeys() {
  return Array.from(fileStore.keys());
}

